import React, {useState} from "react";
import {Button, Col, Input, List, Modal, Row} from "antd";
import {AlertParametersModel, AlertParametersTypeModel} from "../../../../types/api/alertParameters";
import {useTranslation} from "react-i18next";
import {capitalize} from "lodash";
import {useUpdateAlertParametersMutation} from "../../../../redux/api/alertParameters";
import CustomNumericFormat from "../../../common/customNumeric/CustomNumericFormat";
import {NumericFormat, NumericFormatProps} from "react-number-format";
import {useGetUserProfileQuery} from "../../../../redux/api/locales";
import PermissionRoute from "../../../Authentication/PermissionRoute";
import {isAlertParametersEdit} from "../../../Authentication/permissions";

export default function AlertParametersTypeItem({param, paramType, index}: {
  param: AlertParametersModel,
  paramType: AlertParametersTypeModel | undefined,
  index: number
}) {

  const {t} = useTranslation()

  const [updateParam] = useUpdateAlertParametersMutation()

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [inputValue, setInputValue] = useState<number | undefined>(param.value)

  const {data} = useGetUserProfileQuery();
  let props: NumericFormatProps<any> = {
    customInput: Input,
    decimalScale: paramType?.decimals,
  };

  if (data?.language === 'it') {
    props = {
      thousandSeparator: '.',
      decimalSeparator: ',',
      ...props,
    };
  }

  const onSave = () => {
    updateParam({uuid: param.uuid, value: inputValue}).unwrap()
      .then(() => setIsModalOpen(false))
  }

  const renderModal = () => {
    return <PermissionRoute isAuthorized={isAlertParametersEdit}>
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        title={paramType?.label}
        onOk={() => onSave()}
        okText={capitalize(t('actions.save'))}
      >
        <p>
          {t('assets.setAlertParameter')}
        </p>
        <NumericFormat
          value={param?.value}
          suffix={paramType?.um ? " " + paramType.um : ""}
          onValueChange={values => setInputValue(values.floatValue)}
          {...props}
        />
      </Modal>
    </PermissionRoute>
  }

  return <>
    {isModalOpen && renderModal()}
    <List.Item key={index}>
      <Row style={{width: "100%"}}>
        <Col xs={8}>
          {paramType?.label}
        </Col>
        <Col xs={8}>
          <Row justify={"center"}>
            <strong>
              <CustomNumericFormat
                value={param?.value}
                suffix={paramType?.um ? " " + paramType.um : ""}
                displayType={"text"}
                decimalScale={paramType?.decimals}
              />
            </strong>
          </Row>
        </Col>
        <PermissionRoute isAuthorized={isAlertParametersEdit}>
          <Col flex={1}>
            <Row justify={"end"}>
              <Button onClick={() => setIsModalOpen(true)}>
                {capitalize(t('actions.edit'))}
              </Button>
            </Row>
          </Col>
        </PermissionRoute>
      </Row>
    </List.Item>
  </>
}